var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('error-modal',{attrs:{"show":_vm.showErrorModal,"error":_vm.currentError,"retry-action":_vm.retryAction},on:{"close":_vm.hideError}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }